module.exports = __webpack_public_path__ + "img/Dantam Bridal 23.f066668b.jpg";